import z from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';
import { ImageObjectSchema } from './Image';

export const PageHeroSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.PageHero),
  headline: z
    .object({
      svg: ImageObjectSchema.nullish(),
      text: z.string().nullish().default('Headline')
    })
    .nullish(),
  background: z.object({
    image: ImageObjectSchema,
    altText: z
      .string()
      .nullable()
      .transform((x) => x ?? '')
  })
});

export type PageHero = z.infer<typeof PageHeroSchema>;
